import { Seo } from '@portals/sip-client-data/src/general/ApiClientTypes';
import { ConfigProvider } from '@portals/sip-client-data/src/general/Config';
import Head from 'next/head';
import React from 'react';

export const SeoHeader = (props: { seo: Seo; id: string }): JSX.Element => {
  return (
    <Head>
      <title key="html:title">{`${props.seo.title} | Sparkassen-Immobilien`}</title>
      <meta key="og:title" property="og:title" content={props.seo.title} />
      <meta key="og:description" property="og:description" content={props.seo.description} />
      <meta
        key="og:url"
        property="og:url"
        content={`${ConfigProvider.getConfig().get('NEXT_PUBLIC_HOST')}/expose/${props.id}.html`}
      />
      <meta key="og:type" property="og:type" content="website" />
      <meta key="og:locale" property="og:locale" content="de_DE" />
      <meta key="og:type" property="og:type" content="article" />
      <meta key="og:site_name" property="og:site_name" content="Sparkassen Immobilien" />
      <meta name="robots" content="index,follow" />
    </Head>
  );
};
SeoHeader.displayName = 'SeoHeader';
